import React from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import useAction from 'actionHub/hooks/useAction'
import { Switch } from 'react-router-dom'
import { push } from 'connected-react-router'
import { hot } from 'react-hot-loader/root'
import Loading from 'components/Loading'
import MultiProgressBar from 'components/MultiProgressBar'
import useJob from 'hooks/useJob'
import { Helmet } from 'react-helmet'
import ReportHeader from 'components/ReportHeader'
import useApp from 'hooks/useApp'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import styles from './ActionHome.scss'

function ActionHome({ routes, match: { params: { actionSetId } } }) {
  const STATUS_COMPLETED = 3

  const dispatch = useDispatch()
  const useActionResults = useAction(actionSetId)
  const {
    actionSet, jobId, isCurrent, goToOtherAction,
    isFetched, mainAggregation, statuses,
  } = useActionResults

  const useJobResults = useJob(jobId)
  const {
    jobName, goToJob, getNavigationOptions,
    showExpiryInfoBanner, isAssignedActionsEditor, actions, canAccessJobActions,
  } = useJobResults

  const {
    user,
  } = useApp()

  if (canAccessJobActions === false) {
    dispatch(push('/error?forbidden'))
  }

  if (!isFetched || !jobName || !actions) {
    return <Loading pageLoading />
  }

  // Header config
  const {
    options, optionGroups, reportActionButton,
  } = getNavigationOptions(actionSet, isCurrent, goToOtherAction)

  const completedActions = statuses?.find(x => x.id === STATUS_COMPLETED).count
  const { totalActions } = mainAggregation
  const completionProgress = (totalActions !== 0) ? (completedActions / totalActions) : 0

  return (
    <div className={styles.base}>
      <Helmet>
        <title>
          {`InsightBox | ${jobName} | Actions`}
        </title>
      </Helmet>
      <ReportHeader
        actionButton={reportActionButton}
        completionProgress={completionProgress}
        goBack={() => goToJob('actions')}
        jobId={jobId}
        navigationOptionGroups={optionGroups}
        navigationOptions={isCurrent ? options : null}
        navigationValue={actionSet.id}
        type="action"
        user={user}
      />
      {!showExpiryInfoBanner && !isAssignedActionsEditor && (
        <MultiProgressBar
          denominator={totalActions}
          roundEdges={false}
          value={completedActions}
        />
      )}
      <Switch>
        {routes.map(route => (
          <RouteWithSubRoutes
            key={route.path}
            {...route}
            useAction={useActionResults}
            useJob={useJobResults}
          />
        ))}
      </Switch>
    </div>
  )
}

ActionHome.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      actionSetId: PropTypes.string,
    }),
  }).isRequired,
  routes: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string,
  })).isRequired,
}

export default hot(ActionHome)

